/**
 * @description Provides styled components for the user icons used in the application bar and the user menu.
 */

import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import styled from '@mui/system/styled';

const getStyles = ({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.seccon.main,
  border: 0,
  borderRadius: '50%',
  color: theme.palette.seccon.contrastText,
  display: 'flex',
  fontSize: '1.25rem',
  fontWeight: 'bold',
  height: '3.125rem',
  justifyContent: 'center',
  padding: 0,
  textTransform: 'uppercase',
  width: '3.125rem',

  '&:hover': {
    backgroundColor: theme.palette.seccon.light
  },

  '&:active, &:focus': {
    backgroundColor: theme.palette.seccon.main
  }
});

// This component is used in the application bar. It provides a button to launch the user menu.
export const NavUserIcon = styled(IconButton)(getStyles);

// This component is used in the user menu. It displays a smaller version of the user icon above a position absolute background
export const NavUserMenuIcon = styled(Box)(({ theme }) => ({
  ...getStyles({ theme }),
  fontSize: '0.75rem',
  height: '2rem',
  width: '2rem',
  zIndex: 2
}));
